/**
 * @generated SignedSource<<3a5cf2455a36f6992b5ab234b23d92fe>>
 * @relayHash 7e0286ef53389b92ea759caade86ad6f
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7e0286ef53389b92ea759caade86ad6f

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "sendForSignature",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SendForSignatureMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SendForSignatureMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "7e0286ef53389b92ea759caade86ad6f",
    "metadata": {},
    "name": "SendForSignatureMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "e92d601e35232e53ded14119ff5317da";

export default node;
